module.exports = __webpack_public_path__ + "static/img/huo_jkfa_icon.png";